import keyMirror from "keymirror";

export default keyMirror({
    threeFaces: null,
    twoFaces: null,
    fourFacesHappyToSad: null,
    fourFacesSadToHappy: null,
    fiveFacesHappyToSad: null,
    fiveFacesSadToHappy: null,
    fiveStars: null,
});
